import { Card, Col, Container, Row } from "react-bootstrap";
import FormRentPlace from "../components/FormRentPlace";
import ChangeCountry from "../components/ChangeCountry";

export default () => {
  return (
    <Container className="my-5">
      <Row className="justify-content-center">
        <Col md={8} lg={6} xl={4}>
          <Card>
						<Card.Body>
              <h3 className="text-center mb-3">Rent a place</h3>
              <FormRentPlace />
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};
